export default __webpack_public_path__ + "static/media/popcorn3x.9033e28f.png";